import type { IPublisher, PostContentType } from "@chaosinsight/postoffice-portalclient"
import Configuration from "@/managers/system/configuration"

export default class Publisher {
	public readonly id: number
	public readonly isBuiltIn: boolean

	public isActive: boolean
	public isEventsEndpoint: boolean
	public name: string
	public logoUrl: string
	public endpointUrl: string | null
	public supportedPostTypes: PostContentType[]

	public handshakeError: string | null

	public get canCreateMultipleConnections(): boolean {
		return this.isBuiltIn
	}

	private constructor(id: number, isBuiltIn: boolean, isActive: boolean, isEventsEndpoint: boolean, name: string, logoUrl: string, endpointUrl: string | null, supportedPostTypes: PostContentType[], handshakeError: string | null) {
		this.id = id
		this.isBuiltIn = isBuiltIn

		this.isActive = isActive
		this.isEventsEndpoint = isEventsEndpoint
		this.name = name
		this.logoUrl = logoUrl
		this.endpointUrl = endpointUrl
		this.supportedPostTypes = supportedPostTypes

		this.handshakeError = handshakeError
	}

	public updateFromApi(publisher: IPublisher): Publisher {
		this.isActive = publisher.IsActive
		this.isEventsEndpoint = publisher.IsEventsEndpoint
		this.name = publisher.Name!
		this.endpointUrl = publisher.EndpointUrl
		this.supportedPostTypes = publisher.SupportedPostTypes

		this.handshakeError = publisher.HandshakeError

		return this
	}

	public static fromApi(publisher: IPublisher, fallbackLogoUrl: string): Publisher {
		return new Publisher(
			publisher.Id,
			publisher.IsBuiltIn,
			publisher.IsActive,
			publisher.IsEventsEndpoint,
			publisher.Name!,
			Publisher.getLogoUrl(publisher.Id!) ?? fallbackLogoUrl,
			publisher.EndpointUrl,
			publisher.SupportedPostTypes,
			publisher.HandshakeError)
	}

	private static getLogoUrl(id: number): string | null {
		switch (id) {
			case Configuration.publishers.builtIn.Facebook:
				return require('@/assets/icons/po-icons/social/facebook.svg')
			case Configuration.publishers.builtIn.Instagram:
				return require('@/assets/icons/po-icons/social/instagram.svg')
		}
		return null
	}
}
